
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const shippinglabelcontentsApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listShippingLabelContentss: builder.query ({
      query: (params) => `v2/shippinglabelcontents/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["ShippingLabelContents"]
    }),
    getShippingLabelContents: builder.query ({
      query: (shippinglabelcontents_id) => `v2/shippinglabelcontents/${shippinglabelcontents_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["ShippingLabelContents"]
    }),

    updateShippingLabelContents: builder.mutation ({
      query: ({shippinglabelcontents_id, data}) => ({
        url: `v2/shippinglabelcontents/${shippinglabelcontents_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["ShippingLabelContents"]
    }),
    deleteShippingLabelContents: builder.mutation ({
      query: (shippinglabelcontents_id) => ({
        url: `v2/shippinglabelcontents/${shippinglabelcontents_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["ShippingLabelContents"]
    }),
    createShippingLabelContents: builder.mutation ({
      query: (data) => ({
        url: `v2/shippinglabelcontents/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["ShippingLabelContents"]
    }),
  })
})


export const {
  useListShippingLabelContentssQuery,
  useLazyListShippingLabelContentssQuery,
  useGetShippingLabelContentsQuery,
  useLazyGetShippingLabelContentsQuery,

  useUpdateShippingLabelContentsMutation,
  useDeleteShippingLabelContentsMutation,
  useCreateShippingLabelContentsMutation
} = shippinglabelcontentsApi
